<template>
    <div class="_div_2">
      <div @click="assignToWorkflow" style="display:inline;">
        <slot>
          <a title="选择工作流[5]" style="float:right;">工作流</a>
        </slot>
      </div>

      <el-dialog
        top="5vh"
        :modal="false"
        title="选择工作流"
        :visible.sync="dialogVisible"
        @opened="loadMyWorkflow"
        width="75%">
          <el-table
              :data="workflowList"
              border
              highlight-current-row
              height="80vh"
              style="width:100%;overflow: scroll;">

              <el-table-column type="index"/>

              <el-table-column label="ID">
                <template slot-scope="scope">{{scope.row.id}}</template>
              </el-table-column>

              <el-table-column label="Name">
                <template slot-scope="scope">{{scope.row.name}}</template>
              </el-table-column>

              <el-table-column label="Description">
                <template slot-scope="scope">{{scope.row.description}}</template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <a @click="selectWorkflow(scope)">选择</a>
                  <a target="_blank" :href="'/ticket/activiti_model_viewer?modelId=' + scope.row.id">查看</a>
                </template>
              </el-table-column>
          </el-table>
        </el-dialog>
    </div>
</template>

<style scoped>
._div_2 {
    display: inline;
}
</style>

<script>
export default {
  name: "AssignToWorkflowDialog",

  props : ["value"],

  data() {
    return {
      dialogVisible : false,
      workflowList : []
    };
  },

  methods: {
    selectWorkflow(scope) {
      this.dialogVisible = false;
      this.$emit('change', scope.row.id, scope.row);
    },

    assignToWorkflow() {
      this.dialogVisible = true;
    },

    loadMyWorkflow() {
      var _this = this;
      sdk.TicketWorkflowApi().listMyWorkflowCached({
        page : { pageSize : 9999, orderBy : '`index` DESC' }
      }).then(res => {
        _this.workflowList = res.list;
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/AssignToWorkflowDialog.vue